/**
 * Identify the current Clerk user + tenant to Sentry.
 *
 * Called from `SentryIdentityBridge` whenever the Clerk session, the
 * active organisation, or the chosen Legal Entity changes. Passing
 * `null` for any field clears that signal — handy on sign-out.
 */

import * as Sentry from "@sentry/react";

export interface IdentifyArgs {
  clerkUserId: string | null;
  tenantSlug: string | null;
  legalEntityId: string | null;
}

export function identifyUser(args: IdentifyArgs): void {
  Sentry.setUser(args.clerkUserId ? { id: args.clerkUserId } : null);
  Sentry.setTag("tenant_slug", args.tenantSlug || "unknown");
  if (args.legalEntityId) {
    Sentry.setTag("legal_entity_id", args.legalEntityId);
  }
}
